export enum ETableAction {
	edit = 'edit',
	clone = 'clone',
}